define('views/pages/organization/users/navbar',['require','jquery','views/base/view','text!templates/pages/organization/users/navbar.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        View = require('views/base/view'),
        template = require('text!templates/pages/organization/users/navbar.ejs');

    /*
        ORGANIZATION USERS NAVBAR
    */

    var OrganizationUsersNavbarView = View.extend({
        region: 'organization-users-navbar',
        autoRender: true,
        className: 'navbar-inner',
        template: template,
        events: {
            'click a': 'onClickButton'
        },
        listen: {
            'change:selected model': 'render'
        },
        onClickButton: function(ev){
            this.model.trigger($(ev.currentTarget).data('action').toLowerCase());
        }
    });

    return OrganizationUsersNavbarView;
});

